
import { Component, Vue, Prop} from 'vue-property-decorator';
import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";

import PpmQuestionnaire from "./PpmQuestionnaire.vue";
import PriorityParentingMatterOrder from "./PriorityParentingMatterOrder.vue"
import PpmBackground from "./PpmBackground.vue";
import PpmChildrenInfo from "./childInfo/PpmChildrenInfo.vue";
import AboutPriorityParentingMatterOrder from "./AboutPriorityParentingMatterOrder.vue"
import PpmIndigenousAncestryOfChild from "./PpmIndigenousAncestryOfChild.vue";
import PpmAdditionalDocuments from "./PpmAdditionalDocuments.vue"

import ReviewYourAnswersPpm from "./reviewPPM/ReviewYourAnswersPPM.vue"
import PreviewFormsPpm from "./reviewPPM/PreviewFormsPPM.vue"

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        StepBase,
        PpmQuestionnaire,
        PriorityParentingMatterOrder,
        PpmBackground, 
        PpmChildrenInfo,
        AboutPriorityParentingMatterOrder,   
        PpmIndigenousAncestryOfChild, 
        PpmAdditionalDocuments,  
        ReviewYourAnswersPpm,
        PreviewFormsPpm
    }
})
export default class ParentingPriorityStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

}

